import React, { useEffect, useMemo, useRef, useState } from 'react';
import {
  strToObject } from '@/pages/dashboard/utils/utils';
import Permission from '@/pages/dashboard/components/NoPermission';
import Loading from '@/pages/dashboard/components/Loadings';
import { embedDashboard } from "@/pages/dashboard/_plugins/preset-sdk";
import { IPresetReportType } from '../../pages/report/type';
import { getPresetInfo } from '@home/services/report';
import classNames from 'classnames';

interface ReportInfoType {
  loading: boolean;
  noReport: boolean;
}

const INIT_REPORT_INFO:ReportInfoType = {
  noReport: false,
  loading: false
};

export default (props: IPresetReportType ) => {
  const [reportInfo, getReportInfo] = useState<ReportInfoType>(INIT_REPORT_INFO);
  const presetRef = useRef<any>(null);
  const { url, presetId, extInfo, className = '', style: propsStyle = {}, onSuccess, onFail, apiUrl = '/api/v1/permission/preset/guest_token/dashboard/' } = props;

  const setState = (params = {}) => {
    getReportInfo({
      ...INIT_REPORT_INFO,
      ...params
    });
  };

  const errorInfo = useMemo(() => {
    if (reportInfo.loading) {
      return <Loading />;
    }
    // 路径中无reportid
    if (reportInfo.noReport) {
      return <Permission type="error" textCN="未获取到报表信息" />;
    }
    return null;
  }, [reportInfo]);

  useEffect(() => {
    // preset 处理逻辑
    const openPresetReport = () => {
      if (!url || !presetId) {
        presetRef.current?.unmount();
        setState({
          noReport: true
        });
        return;
      }
      setState({
        loading: true
      });

      getPresetInfo(url, apiUrl).then(presetInfo => {
        const { guest_token: guestToken, workspace_region: workspaceRegion, workspace_name: workspaceName } = presetInfo || {};
        if (!guestToken) {
          setState({
            noReport: true,
          });
          return;
        }
        setState({
          loading: false
        });

        let fetchNum = 0;   
        const dashboardUiConfig= extInfo ? {
          hideTitle: true,
          hideTab: true,
          hideChartControls: false,
          filters:
            strToObject(extInfo)
        } : {
          hideTitle: true,
          hideTab: true,
          hideChartControls: false,
        };
        
        embedDashboard({
          id: presetId, // given by the Superset embedding UI
          supersetDomain: `https://${workspaceName}.${workspaceRegion}.app.preset.io`,
          mountPoint: document.getElementById('report-iframe-wrap') as HTMLElement, // any html element that can contain an iframe
          fetchGuestToken: () => {
            fetchNum+= 1;
            if (fetchNum === 1) {
              return guestToken;
            }
            return getPresetInfo(url, apiUrl).then(data => data?.guest_token || '', () => '');
          },
          dashboardUiConfig, // dashboard UI config: hideTitle, hideTab, hideChartControls (optional)
        }).then(preset => {
          presetRef.current = preset;
          onSuccess?.();
        });
      }, () => {
        presetRef.current?.unmount();
        setState({
          noReport: true
        });
        onFail?.();
      }).catch(e=>{
        console.log(e);
      });
    };

    openPresetReport();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [url, presetId]);

  const style = {
    display: errorInfo ? 'none' : 'block',
    ...propsStyle
  };

  return (
    <>
      {/* 优化如上代码，避免当getPresetInfo请求失败时presetRef.current?.unmount()报错 页面白屏 */}
      { errorInfo && <div className={classNames('dtb-db-iframe-wrap db-report-preset', className)}>{errorInfo}</div>} 
      <div className={classNames('dtb-db-iframe-wrap db-report-preset', className)} id="report-iframe-wrap" style={style} />
    </>
  );
};
